import { Button, Dialog, Text } from '@noorden-insurtech/alba-design-system';
import { AlertTriangle } from 'lucide-react';

type Props = {
  isOpen: boolean;
  isConfirmLoading: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export function CapitalGlobalProposalConfirmSignatureMethodModal({
  isOpen,
  isConfirmLoading,
  onConfirm,
  onClose,
}: Props) {
  // O Dialog do design system entrega `{ open }`, não o booleano cru.
  const handleOpenChange = (details: { open: boolean }) => {
    if (!details.open && !isConfirmLoading) {
      onClose();
    }
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content className='w-[480px] max-w-[480px] rounded-[24px] p-6 shadow-xl'>
          <div className='flex flex-col items-start gap-8'>
            <Dialog.Header className='w-full p-0'>
              <Dialog.Title className='w-full'>
                <div className='flex w-full items-center justify-between gap-3'>
                  <div className='flex items-center gap-2'>
                    <AlertTriangle className='h-6 w-6 text-alba-black-500' />
                    <Text className='text-lg font-bold text-alba-black-500'>
                      Atenção!
                    </Text>
                  </div>
                  <Dialog.CloseButton
                    onClick={onClose}
                    disabled={isConfirmLoading}
                  />
                </div>
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body className='w-full px-6 py-0'>
              <div className='flex flex-col items-start gap-3'>
                <Text className='text-sm text-alba-gray-600'>
                  Ao confirmar, não será mais possível alterar o método de
                  assinatura.
                </Text>
                <Text className='text-sm text-alba-gray-600'>
                  Deseja continuar?
                </Text>
              </div>
            </Dialog.Body>

            <Dialog.Footer className='w-full p-0 px-6'>
              <div className='flex w-full items-center justify-end gap-6'>
                <Button
                  variant='ghost'
                  size='md'
                  onClick={onClose}
                  disabled={isConfirmLoading}
                >
                  Cancelar
                </Button>
                <Button
                  variant='primary'
                  size='md'
                  loading={isConfirmLoading}
                  disabled={isConfirmLoading}
                  onClick={onConfirm}
                >
                  Confirmar
                </Button>
              </div>
            </Dialog.Footer>
          </div>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
